<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-responsive-sm">
          <thead>
            <tr>
              <th>{{ $t("labels.drug") }}</th>
              <th>{{ $t("labels.quantity") }}</th>
              <th>{{ $t("labels.drugNotes") }}</th>
              <th>{{ $t("labels.startDate") }}</th>
              <th>{{ $t("labels.endDate") }}</th>
            </tr>
          </thead>
          <tbody>
            <template tr v-for="(d, index) in therapyDrugs">
              <tr v-if="!d['delete']" :key="index">
                <td>
                  <template v-if="d.drugId != null">
                    {{
                      d.drugId.name[$i18n.locale]
                        ? d.drugId.name[$i18n.locale]
                        : d.drugId.name["en"]
                    }}
                  </template>
                  <template v-else>
                    <select class="form-control" v-model="therapyDrugs[index].drugId" @change="doFilterDrugs">
                      <option :value="null"></option>
                      <template v-for="(drug, index) in filteredDrugs">
                          <option :value="drug" :key="index">
                            {{ 
                              drug.name[$i18n.locale]
                              ? drug.name[$i18n.locale]
                              : drug.name["en"] 
                            }}
                          </option>  
                      </template>
                    </select>
                  </template>  
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="therapyDrugs[index]['quantity']"
                  />
                </td>
                <td>
                  <textarea
                    class="form-control"
                    id="drugNotes"
                    v-model="therapyDrugs[index]['notes']"
                    placeholder
                    rows=3
                  ></textarea>
                </td>
                <td>
                  <date-picker
                    v-model="therapyDrugs[index]['startDate']"
                    :lang="$i18n.locale"
                    width="100%"
                    type="date"
                    appendToBody
                    :clearable="false"
                    format="DD/MM/YYYY"
                  >
                  <template v-slot:calendar-icon>
                    <span></span>
                  </template>
                  </date-picker>
                </td>
                <td>
                  <date-picker
                    v-model="therapyDrugs[index]['endDate']"
                    :lang="$i18n.locale"
                    width="100%"
                    type="date"
                    appendToBody
                    :clearable="false"
                    format="DD/MM/YYYY"
                  >
                  <template v-slot:calendar-icon>
                    <span></span>
                  </template>
                  </date-picker>
                </td>
              </tr>
              <tr v-if="!d['delete']" :key="index + '-actions'" >
                <td colspan="5" style="border-top: none">
                  <button href="#" @click.prevent="removeDrug(index)" class="btn btn-danger btn-icon"> <i class="fa fa-remove"></i></button>
                </td>
              </tr>
            </template>
            <tr key="add-drug">
              <td colspan="5">
                 <button href="#" @click.prevent="addDrug()" class="btn btn-info">{{ $t("labels.addDrug") }}</button>
              </td>
            </tr>
          </tbody>
        </table>
    
      </div>
      <div class="col-md-2">
        <button href="#" @click.prevent="saveTherapyDrugs()" class="btn btn-info">{{ $t("labels.save") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import LovService from "@/services/lov";
import { ModelListSelect } from "vue-search-select";
import Swal from 'sweetalert2'
export default {
  props: {
    patient: Object,
    currentTherapyDrugs: Array,
    therapyDrugsHistory: Array
  },
  components: {
    ModelListSelect,
  },
  data() {
    return {
      drug: {
        quantity: '',
        notes: '',
        startDate: '',
        endDate: null,
        delete: false,
        patientId: this.patient._id
      },
      therapyDrugs: [],
      drugs: [],
      filteredDrugs: [],
      drugErrors: [],
      selectedDrug: "",
      selectedDrugQuantity: "",
      selectedDrugNotes: "",
      bloodLevel: "",
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
  },
  watch: {
    drugLines: {
      handler(value) {
        let self = this;
        // create a loop here which goes through every array element, and finds the corresponding drug by id, then replaces name with new drug name
        value.forEach(function (d) {
          let drug = self.drugs.find(function (item) {
            return item._id === d.id;
          });
          if (drug != null) {
            d.name = drug.name;
          }
        });
      },
      deep: true,
    },
  },
  mounted: async function () {
    let that = this
    let drugs = await LovService.all("drug", false);
    this.therapyDrugs = this.currentTherapyDrugs
    if (drugs) {
      this.drugs = drugs.data;
      this.filteredDrugs = this.filterDrugs(drugs.data, this.therapyDrugs)
    }
    if (this.currentRoute !== "newPatient") {
      this.therapyForm = false;
    }
  },
  methods: {
    alertMe() {
      alert("Hello world!");
    },
    onChange(event) {
      alert("Changed");
    },
    onDrugSelect(drug) {
      this.selectedDrug = drug._id;
    },
    drugName(drug) {
      return drug.name[this.$i18n.locale]
        ? drug.name[this.$i18n.locale]
        : drug.name["en"];
    },
    addDrug() {
      var that = this
      this.therapyDrugs.push(
        Object.assign({}, that.drug)
      )
    },
    removeDrug: async function(index){ 
      let confirmDelete = await Swal.fire({
        title: this.$t("labels.areYouSure"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("labels.confirmDelete"),
        cancelButtonText: this.$t("labels.cancelDelete")
      })
      if (confirmDelete.value) {
        this.$set(this.therapyDrugs, index, Object.assign({}, this.therapyDrugs[index], {'delete': true}))
      }
      this.doFilterDrugs()
    },
    editDrug(d) {
      this.$set(d, "editMode", true);
      console.log(d);
    },
    cancelEdit(d) {
      this.$set(d, "editMode", false);
    },
    filterDrugs(drugs, therapyDrugs){
      let filteredDrugIds = _.filter(therapyDrugs, function(td){
        return td['delete'] != null ? !td['delete'] : true
      }).map(function(td){ return td.drugId._id})
      return _.filter(drugs, function(drug){
        return filteredDrugIds.indexOf(drug._id) == -1
      });
    },
    doFilterDrugs(){
      let that = this
      that.$nextTick(function(){
        that.filteredDrugs = that.filterDrugs(that.drugs, that.therapyDrugs)
      })
    }, 
    saveTherapyDrugs() {
      let cleanTherapyDrugs = this.therapyDrugs.map(function(td){
        td['id'] = td['_id']
        td['drugId']['id'] = td['drugId']['_id']
        return td
      })
      this.$emit('save-therapyDrugs', cleanTherapyDrugs);
    }
  },
};
</script>

